<template>
  <div class="filters-row">
    <div><base-select @search="loadServices($event)" searchable clearable :loading="filters.service.loading" :options="filters.service.options" valueProp="id" :label="$i18nHelpers.normalizeProp('name')" v-model="filters.service.value" :placeholder="filters.service.placeholder"></base-select></div>
    <hr>
    <div><base-select searchable clearable :loading="filters.location.loading" :options="filters.location.options" valueProp="id" label="name" v-model="filters.location.value" :placeholder="filters.location.placeholder"></base-select></div>
    <div class="text-center my-4"><base-button @click="search()" class="w-100">{{$t('filters.showResults')}}</base-button></div>
  </div>
</template>

<script>
import healthServicesRepository from '@/repositories/HealthServicesRepository'
import geographyRepository from '@/repositories/GeographyRepository'
import { SCREEN_LG_GRID } from '@/constants/mediaQueries'

export default {
  data () {
    return {
      filters: {
        service: {
          loading: false,
          options: [],
          placeholder: this.$t('filters.service'),
          value: null
        },
        location: {
          loading: false,
          options: [],
          placeholder: this.$t('filters.location'),
          value: null
        }
      }
    }
  },
  created () {
    if (Object.keys(this.$route.query).length > 0) {
      this.filters.service.value = this.$route.query.service || null
      this.filters.location.value = parseInt(this.$route.query.location) || null
      this.search(!!this.$route.query.showServicesRequest, this.$route.query.userId, this.$route.query.service)
      // window.history.replaceState(null, '', window.location.pathname)
    }
    this.loadServices()
    this.loadCities()
  },
  computed: {
    mobileVersion () {
      return window.innerWidth < SCREEN_LG_GRID
    }
  },
  methods: {
    loadCities () {
      geographyRepository.getStatesByService(this.filters.service.value).then(response => {
          this.filters.location.options = response.data
      })
    },
    loadServices (search) {
      this.filters.service.loading = true
      healthServicesRepository.getCenterAndProfHealthServicesByNameAndCity(search, this.filters.location.value).then((response) => {
          this.filters.service.options = response.data
          this.filters.service.loading = false
      })
    },
    search (showServicesRequest, userId, serviceId) {
      let params = {}
      let emptyFilters = Object.keys(this.filters).every(key => {
        return this.filters[key].defaultValue ? this.filters[key].value === this.filters[key].defaultValue : !this.filters[key].value
      })
      if (emptyFilters && !userId) {
        this.$store.dispatch('showInfoAlert', this.$t('filters.selectFilter'))
        return
      }
      Object.keys(this.filters).forEach(key => { params[key] = this.filters[key].value })
      if (showServicesRequest) params.showServicesRequest = true
      if (userId) params.userId = userId
			if (serviceId) params.serviceId = serviceId
      this.$emit('search', params)
    }
  },
  watch: {
    'filters.location.value' () {
      this.loadServices()
    },
    'filters.service.value' () {
      this.loadCities()
    }
  }
}
</script>

<style lang="scss" scoped>
.filters-row{
  hr {
    margin-top: 1rem;
    margin-bottom: 1rem;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/webapp/patient/search/services/SearchServicesFilters.vue